// datetime-local inputs need "YYYY-MM-DDTHH:mm" in local time, with no
// trailing "Z"/offset — Date#toISOString is UTC, so trim it by hand instead.
export const toDateTimeLocalValue = (isoString) => {
  if (!isoString) return "";
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
